import React, { useEffect, useState, useContext } from "react";
import { observeActiveSaleOrderByBusiness } from "../../../../database/helpers/sale_order";
import { InnerWrapper, TitleAndActionBox } from "../../../common";
import { setCurrentScreen } from "firebase/analytics";
import { analytics, triggerLogEvent } from "../../../../config/firebase";
import { CheckoutOrder, SaleOrderSummary } from "../../../container/SaleBook";
import withObservables from "@nozbe/with-observables";
import { LanguageContext } from "../../../../context/LanguageContext";
import { Grid } from "@mui/material";
import { of, switchMap } from "rxjs";
import { useNavigate } from "react-router-dom";
import { useAuthContext } from "../../../../context/AuthContext";
import {
  KeyboardShortcutsModal,
  UBButton,
} from "../../../../Libraries";
import {
  ArrowDown,
  ArrowUp,
  Keyboard,
} from "../../../../assets/icons/icon";
import { Box, Tooltip } from "@mui/material";
import styles from "../styles.module.css";

const KeyboardShortcutKey = [
  { btnTitle: "Space", label: "Switch between the tabs", labelKey: "shortcut_switch_tabs" },
  { btnTitle: <ArrowUp />, label: "Scroll up", labelKey: "shortcut_scroll_up" },
  { btnTitle: "Enter", label: "Add customer", labelKey: "shortcut_add_customer" },
  { btnTitle: <ArrowDown />, label: "Scroll down", labelKey: "shortcut_scroll_down" },
  { btnTitle: "Shift + Enter", label: "Charge", labelKey: "shortcut_charge" },
];

const gridColumnSx = {
  display: "flex",
  flexDirection: "column",
  minHeight: 0,
  minWidth: 0,
  height: "100%",
};

const OrderSummay = ({ activeSaleOrder, customer }) => {
  activeSaleOrder = activeSaleOrder.length
    ? activeSaleOrder[0]
    : activeSaleOrder;
  const [totalAmountOrder, setTotalAmountOrder] = useState(0);
  const [shortcutKeyModal, setShortcutKeyModal] = useState(false);

  const navigate = useNavigate();
  const { user, business } = useAuthContext();
  const [I18n] = useContext(LanguageContext);

  const calculateTotalAmountOrder = (amount) => {
    setTotalAmountOrder(amount);
  };

  useEffect(() => {
    setCurrentScreen(analytics, "Sale_Pos_Order_Summary_screen");
  }, []);

  useEffect(() => {
    if (activeSaleOrder.length === 0) {
      navigate(`/${"SaleBook"}`, { replace: true });
    }
  }, [activeSaleOrder, navigate]);

  return (
    <Box className={styles.SaleBookWrapper} padding={"8px 20px"}>
      <Box>
        <TitleAndActionBox
          data={{
            title: I18n.checkout,
            isBack: true,
            id: "order_summary",
          }}
        >
          <Tooltip title={I18n.keyboard_shortcut_tooltip || "Keyboard shortcut"}>
            <UBButton
              id="order_summary_shortcut"
              className={
                "keyboardButton buttonTeritary buttonTeritaryIcon marginLeft15"
              }
              title={<Keyboard width={30} height={30} />}
              onClick={() => {
                triggerLogEvent(analytics, "pos_keyboard_icon");
                setShortcutKeyModal(true);
              }}
            />
          </Tooltip>
        </TitleAndActionBox>
        <InnerWrapper className={"splitInnerWrapper orderSummaryBox"}>
          <Grid
            container
            sx={{
              height: "100%",
              minHeight: 0,
              minWidth: 0,
              flex: 1,
              width: "100%",
              margin: 0,
            }}
          >
            <Grid item md={6} sx={gridColumnSx}>
              <SaleOrderSummary
                activeSaleOrder={activeSaleOrder}
                calculateTotalAmountOrder={calculateTotalAmountOrder}
              />
            </Grid>
            <Grid item md={6} sx={gridColumnSx}>
              <CheckoutOrder
                totalAmount={totalAmountOrder}
                business={business}
                user={user}
                activeSaleOrder={activeSaleOrder}
                customer={customer}
                navigate={navigate}
              />
            </Grid>
          </Grid>
        </InnerWrapper>
      </Box>
      <KeyboardShortcutsModal
        id="order_summary_shortcuts"
        isOpen={shortcutKeyModal}
        handleClose={() => setShortcutKeyModal(false)}
        shortcuts={KeyboardShortcutKey}
      />
    </Box>
  );
};

const enhance = withObservables([], () => ({
  activeSaleOrder: observeActiveSaleOrderByBusiness(
    localStorage.getItem("business_id")
  ),
  customer: observeActiveSaleOrderByBusiness(
    localStorage.getItem("business_id")
  ).pipe(
    switchMap((saleOrder) =>
      saleOrder.length ? saleOrder[0].customer.observe() : of({})
    )
  ),
}));

export default enhance(OrderSummay);
